module.exports = __webpack_public_path__ + "04a623516a23d59f0e0178d6f5e093f1.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/text/textwidgetexample.png
// module id = 811
// module chunks = 7